import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { Helmet } from "react-helmet";
const Terms = () => {
  const [termsContent, setTermsContent] = useState("");

  useEffect(() => {
    fetch("/terms.md")
    fetch(`${process.env.PUBLIC_URL}/terms.txt`)
      .then((res) => res.text())
      .then((text) => setTermsContent(text))
      .catch((err) => console.error("Failed to load Terms & Conditions", err));
  }, []);

  return (
    <>
      <Helmet>
        <title>T&C - limkc.com</title>
        <meta name="description" content="Read the Terms & Conditions of limkc.com to understand the rules, rights, and responsibilities when using our website and services." />
        <meta name="robots" content="index, follow" />
      </Helmet>
  
      <div className="w-full h-full overflow-auto">
      <div className="px-4 py-6 transition-all duration-300"
   style={{
    paddingTop: 'calc(var(--navbar-height) + 1.5rem)', // Adds navbar height + existing py-6 (1.5rem)
  }}>
          <h2 className="text-xl font-bold mb-4 text-center text-gray-800">Terms & Conditions</h2>
          <p className="text-sm text-gray-500 text-center mb-4">Last Updated: 2025-02-08</p>
          <div className="prose text-gray-600">  {/* ✅ Apply gray text */}
            <ReactMarkdown>{termsContent}</ReactMarkdown>
          </div>
          <div className="text-center mt-6">
            <a href="/register" className="text-blue-500 hover:underline">Back to Register</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Terms;
